import { Erinnerungen } from '@/domain/mitarbeiter/features/rotationsplan/entities/Fristen';
import { getErinnerungsZeitFromFristDatumAndErinnerungsDatum } from '@/domain/mitarbeiter/shared/utils/getErinerungsZeitFromFristDatum/getErinnerungsZeitFromFristDatum';
import { cn } from '@/lib/utils';
import { faAlarmExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

export function ErinnerungenInfo({
  frist,
  erinnerungenAm,
  className,
  ...others
}: {
  frist: Date;
  erinnerungenAm: Erinnerungen[];
} & HTMLAttributes<HTMLDivElement>) {
  const { t } = useTranslation();
  const erinnerungenSet = new Set<string>();
  erinnerungenAm.forEach((e) => {
    try {
      const val = getErinnerungsZeitFromFristDatumAndErinnerungsDatum(
        dayjs(e.datum).format('YYYY-MM-DD'),
        dayjs(frist).format('YYYY-MM-DD'),
      );
      erinnerungenSet.add(
        t(`domain.mitarbeiter.fristen.erinnerungsZeit.options.${val}`),
      );
    } catch (err) {
      console.error(err instanceof Error ? err.message : err);
    }
  });
  return (
    <div
      className={cn(
        `text-neutrals-700 flex gap-1 justify-start items-center text-xs`,
        className,
      )}
      {...others}>
      <FontAwesomeIcon icon={faAlarmExclamation} />
      <span className="whitespace-nowrap truncate">
        {[...erinnerungenSet].join(', ')}
      </span>
    </div>
  );
}
